import { Dispatch } from 'redux'
import { SnackbarAction as Action } from 'src/stores/actions/snackbarActions'
import { EnumSnackbarType, SnackbarTypeFields } from 'src/stores/reducer/snackbarReducer'
import { SnackbarActionType as ActionType } from 'src/stores/action-types/snackbarActionType'

export const snackbarSuccess = (message: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ADD_SNACKBAR,
            payload: {
                [SnackbarTypeFields.Type]: EnumSnackbarType.SUCCESS,
                [SnackbarTypeFields.Message]: message
            }
        })
    }
}

export const snackbarError = (message: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ADD_SNACKBAR,
            payload: {
                [SnackbarTypeFields.Type]: EnumSnackbarType.ERROR,
                [SnackbarTypeFields.Message]: message
            }
        })
    }
}

export const snackbarInfo = (message: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ADD_SNACKBAR,
            payload: {
                [SnackbarTypeFields.Type]: EnumSnackbarType.INFO,
                [SnackbarTypeFields.Message]: message
            }
        })
    }
}

export const snackbarWarning = (message: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.ADD_SNACKBAR,
            payload: {
                [SnackbarTypeFields.Type]: EnumSnackbarType.WARNING,
                [SnackbarTypeFields.Message]: message
            }
        })
    }
}

export const removeSnackbar = (index: number) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.REMOVE_SNACKBAR,
            payload: index
        })
    }
}

export const clearSnackbar = () => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CLEAR_SNACKBAR,
            payload: undefined
        })
    }
}
